// JavaScript Document
( function( $ ) {
$(function() {
    var $tabs = $('.tabs .tab');
    var tabContents = $('.tab-contents');

    $(tabContents).hide();
    $(".tabs .tab:first-child").addClass('active');
    $(".tab-contents:first-of-type").show();

    var filterTabContent = function (id) {
      return $('.tab-contents[data-target="' + id + '"]');
    }

    function switchTabContent() {
      var tabId = $(this).data('target');
      var targetContent = filterTabContent(tabId);
      $('.tab-contents').hide();
      targetContent.fadeIn();
    }

    function activeClass() {
      $('.tabs .tab').removeClass('active');
      $(this).addClass('active');
    }

    $tabs.on('click', switchTabContent);
    $tabs.on('click', activeClass);
  });
  

}( jQuery ) ); // jQuery End